module.exports = __webpack_public_path__ + "static/img/xubin.973926e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/xubin.png
// module id = Tbvf
// module chunks = 0